module.exports = __webpack_public_path__ + "static/media/top-right@2x.c91821df.png";